import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import api from '../services/api';

export default function FaturaTelefonia({ dados, onClose }) {
    const [portalEl] = useState(() => { const el = document.createElement('div'); el.id = 'fatura-portal'; return el; });
    const [baixando, setBaixando] = useState(false);
    useEffect(() => { document.body.appendChild(portalEl); return () => { if (portalEl.parentNode) portalEl.parentNode.removeChild(portalEl); }; }, [portalEl]);
    if (!dados) return null;

    const d = dados;
    const tz = d.timezone || undefined;
    const optTz = tz ? { timeZone: tz } : {};
    const money = (n) => Number(n || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    const moneyTarifa = (n) => Number(n || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 4 });
    const dia = (iso) => iso ? new Date(iso).toLocaleDateString('pt-BR', optTz) : '';
    const hora = (iso) => iso ? new Date(iso).toLocaleString('pt-BR', optTz) : '';
    const cliente = d.cliente || d.cliente_nome || '';
    const agente = d.agente || d.agente_nome || '';
    const numero = d.numero || '';
    const minutos = d.total_minutos !== undefined ? d.total_minutos : (d.minutos || 0);
    const detalhe = Array.isArray(d.ligacoes) ? d.ligacoes : (d.ligacoes_detalhe || []);
    const nlig = d.total_ligacoes !== undefined ? d.total_ligacoes : (typeof d.ligacoes === 'number' ? d.ligacoes : detalhe.length);
    const fimExibe = d.ciclo_fim ? new Date(new Date(d.ciclo_fim).getTime() - 1000).toISOString() : null;
    const mesRefRaw = d.ciclo_inicio ? new Date(d.ciclo_inicio).toLocaleDateString('pt-BR', Object.assign({ month: 'long', year: 'numeric' }, optTz)) : '';
    const mesRef = mesRefRaw ? mesRefRaw.charAt(0).toUpperCase() + mesRefRaw.slice(1) : '';
    const fechada = !!d.criada_em;
    const C = { navy: '#0D1B2A', teal: '#1B9AAA', green: '#06D6A0' };
    const td = { padding: '6px 8px', borderBottom: '1px solid #e3e8ee' };
    const th = { textAlign: 'left', padding: '7px 8px' };

    const baixar = async () => {
        if (!d._pdfUrl) return;
        setBaixando(true);
        try {
            const r = await api.get(d._pdfUrl, { responseType: 'blob' });
            const cd = r.headers['content-disposition'] || '';
            let nome = 'fatura.pdf';
            let m = /filename\*=UTF-8''([^;]+)/i.exec(cd);
            if (m) nome = decodeURIComponent(m[1]); else { m = /filename="([^"]+)"/i.exec(cd); if (m) nome = m[1]; }
            const u = URL.createObjectURL(r.data);
            const a = document.createElement('a'); a.href = u; a.download = nome; document.body.appendChild(a); a.click(); a.remove();
            setTimeout(() => URL.revokeObjectURL(u), 2000);
        } catch (e) { alert('Erro ao gerar o PDF'); }
        finally { setBaixando(false); }
    };

    return ReactDOM.createPortal(
        <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 9999, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '30px 12px' }}>
            <div onClick={e => e.stopPropagation()} style={{ background: '#fff', color: C.navy, width: '100%', maxWidth: 860, borderRadius: 12, padding: '32px 36px', fontFamily: 'Arial, Helvetica, sans-serif', boxShadow: '0 20px 60px rgba(0,0,0,.35)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '3px solid ' + C.teal, paddingBottom: 14, marginBottom: 20 }}>
                    <img src="/neurotech-logo.png" alt="Neurotech-X" style={{ height: 64 }} />
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: 17, fontWeight: 800, color: C.teal, letterSpacing: 1 }}>FATURA DE TELEFONIA</div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>{mesRef}{fechada ? ' — Fechada' : ' — Ciclo em andamento'}</div>
                        <div style={{ fontSize: 10, color: '#5b6b7b', marginTop: 2 }}>K.M.P. Brainwave Repairs Ltda.</div>
                    </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 24px', fontSize: 13, marginBottom: 18 }}>
                    <span><b>Cliente:</b> {cliente}</span>
                    <span><b>Agente:</b> {agente}</span>
                    <span><b>Número de atendimento:</b> {numero}</span>
                    <span><b>Ciclo:</b> {dia(d.ciclo_inicio)}{fimExibe ? ' a ' + dia(fimExibe) : ''}</span>
                </div>
                <div style={{ background: C.navy, color: '#fff', borderRadius: 10, padding: '16px 20px', marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <div style={{ fontSize: 12, letterSpacing: 1, opacity: .85 }}>TOTAL A PAGAR</div>
                        <div style={{ fontSize: 11, opacity: .7, marginTop: 4 }}>{minutos} minutos em {nlig} ligações</div>
                    </div>
                    <div style={{ fontSize: 28, fontWeight: 800, color: C.green }}>{money(d.total)}</div>
                </div>
                <div style={{ fontSize: 13, marginBottom: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px dashed #dbe2ea' }}><span>Módulo de telefonia (mensal)</span><span>{money(d.valor_modulo)}</span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px dashed #dbe2ea' }}><span>Minutos utilizados ({minutos} × {moneyTarifa(d.tarifa_minuto)})</span><span>{money(d.valor_minutos)}</span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontWeight: 800 }}><span>Total</span><span>{money(d.total)}</span></div>
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead><tr style={{ background: C.navy, color: '#fff' }}>
                        <th style={th}>Data/Hora</th><th style={th}>Número</th><th style={th}>Direção</th><th style={{ ...th, textAlign: 'center' }}>Minutos</th>
                    </tr></thead>
                    <tbody>
                        {detalhe.length === 0 && <tr><td colSpan="4" style={{ padding: 10, color: '#5b6b7b', textAlign: 'center' }}>Nenhuma ligação no período</td></tr>}
                        {detalhe.map((l, i) => (
                            <tr key={i}>
                                <td style={td}>{hora(l.inicio)}</td>
                                <td style={td}>{l.numero_contato || ''}</td>
                                <td style={td}>{l.direcao || ''}</td>
                                <td style={{ ...td, textAlign: 'center' }}>{l.minutos}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ marginTop: 24, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                    <button type="button" onClick={onClose} style={{ background: 'transparent', border: '1px solid #c9d2dc', color: C.navy, borderRadius: 6, padding: '10px 16px', cursor: 'pointer' }}>Fechar</button>
                    <button type="button" onClick={baixar} disabled={baixando || !d._pdfUrl} style={{ background: C.teal, color: '#fff', border: 'none', borderRadius: 6, padding: '10px 18px', fontWeight: 700, cursor: baixando ? 'wait' : 'pointer', opacity: baixando ? .7 : 1 }}>{baixando ? 'Gerando PDF...' : 'Baixar PDF'}</button>
                </div>
            </div>
        </div>,
        portalEl
    );
}
